var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isWechat)?_c('button',{on:{"click":function($event){return _vm.openApp(true)}}},[_vm._v("手动打开APP")]):_vm._e(),(_vm.isWechat)?_c('p',[_vm._v("请点击右上角，在浏览器中打开")]):_vm._e(),_c('p',[_vm._v("正在尝试打开 App...")])])}
var staticRenderFns = []

export { render, staticRenderFns }